<template>
  <q-form class="license-state-dialog-container center relative scroller">
    <div class="row items-center icon-container">
      <img
        :src="License_Question_Icon"
        alt="License-Question-Icon"
      />
    </div>
    <div class="dialog-title text-center">{{ $t('generic.licenseStates.licenseNoneNotFound.title') }}</div>
    <div class="dialog-description text-center">
      <div
        v-if="!isLicenseKeyActivated || enteredLicenseKey"
        class="gordita-400-16-r"
      >
        <span>{{ $t('generic.licenseStates.licenseNoneNotFound.loginManualRefreshDesc') }}</span>
        <a
          :href="supportMailUrl"
          class="link-font text-brand_almost_black"
          >{{ supportMailUrl.split(':')[1] }}</a
        >
      </div>
      <div
        v-else
        class="gordita-400-16-r"
      >
        <span>{{ $t('generic.licenseStates.licenseNoneNotFound.heartbeatDescription.a') }}</span>
        <div>
          {{ $t('generic.licenseStates.licenseNoneNotFound.heartbeatDescription.b') }}
          <a
            :href="supportMailUrl"
            class="link-font text-brand_almost_black"
            >{{ supportMailUrl.split(':')[1] }}</a
          >
          <span>{{ $t('generic.licenseStates.licenseNoneNotFound.heartbeatDescription.c') }}</span>
        </div>
      </div>

      <div class="input-container">
        <q-input
          v-model="licenseKey"
          :data-testid="elementsId.dialogs.licenseDialogs.licenseNotFoundNoneDialog.licenseKeyInput"
          class="license-key-input"
          :label="$t('generic.licenseStates.enterLicenseKey')"
          bg-color="white"
          outlined
          lazy-rules
          input-class="brand_almost_black"
          no-error-icon
          @keypress="handleKeyPress($event)"
        />
      </div>

      <div class="button-container">
        <q-spinner-dots
          v-if="licensePending"
          class="text-brand_almost_black"
          style="align-items: center"
          size="4em"
        />
        <q-btn
          v-else
          :data-testid="elementsId.dialogs.licenseDialogs.licenseNotFoundNoneDialog.submitButton"
          flat
          type="submit"
          rounded
          no-caps
          tabindex="3"
          :disabled="!licenseKey"
          :class="{ disabled: !licenseKey }"
          class="submit-button load-key-btn incredi-button-ibx primary-strong enable focus-be-gone"
          :label="$t('generic.licenseStates.loadKey')"
          @click.prevent.stop="submitLicense()"
        />
      </div>
    </div>
  </q-form>
</template>

<script>
import elementsId from '@/const/elementIds.json';
import License_Question_Icon from '@/assets/images/LicenseStatesDialogs/license-question-icon.svg';
import { mapGetters } from 'vuex';
import { defineComponent } from 'vue';
import { licenseDialogMixins } from './licenseDialogMixins';

export default defineComponent({
  name: 'LicenseNotFoundNoneDialog',
  mixins: [licenseDialogMixins],
  props: {
    isLicenseKeyActivated: {
      type: Boolean,
    },
  },
  setup() {
    return {
      License_Question_Icon,
      elementsId,
    };
  },
  computed: {
    ...mapGetters({
      enteredLicenseKey: ['settings/enteredLicenseKeyValue'],
    }),
  },
  watch: {
    enteredLicenseKey: {
      immediate: true,
      handler(newVal) {
        this.licenseKey = newVal;
      },
    },
  },
});
</script>

<style scoped lang="scss">
@import './LicenseDialogsCommonStyle';
</style>
